// frontend/modules/customer-notification/components/common/PlatformSelector.tsx
import React from 'react';
import { Radio, Space, Tooltip } from 'antd';
import { MessageOutlined, WhatsAppOutlined, MailOutlined } from '@ant-design/icons';
import { NotificationPlatforms } from '@/shared/api/model';

interface PlatformSelectorProps {
    value?: NotificationPlatforms;
    onChange?: (value: NotificationPlatforms) => void;
    className?: string;
    disabled?: boolean;
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({
    value,
    onChange,
    className,
    disabled = false
}) => {
    return (
        <Radio.Group
            value={value}
            onChange={(e) => onChange && onChange(e.target.value)}
            className={className}
            disabled={disabled}
            buttonStyle="solid"
        >
            <Tooltip title="SMS">
                <Radio.Button value={NotificationPlatforms.SMS}>
                    <Space>
                        <MessageOutlined />
                        <span>SMS</span>
                    </Space>
                </Radio.Button>
            </Tooltip>
            
            <Tooltip title="WhatsApp">
                <Radio.Button value={NotificationPlatforms.WHATS_APP}>
                    <Space>
                        <WhatsAppOutlined />
                        <span>WhatsApp</span>
                    </Space>
                </Radio.Button>
            </Tooltip>
            
            <Tooltip title="Email">
                <Radio.Button value={NotificationPlatforms.EMAIL}>
                    <Space>
                        <MailOutlined />
                        <span>Email</span>
                    </Space>
                </Radio.Button>
            </Tooltip>
        </Radio.Group>
    );
};

export default PlatformSelector;
